module.exports = __webpack_public_path__ + "static/media/gastro-image1@3x.3cba03dc.png";